module.exports = __webpack_public_path__ + "img/Logo-8.3d54b1ad.svg";